import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(
    () =>
      data?.map(item => ({
        id: item.id,
        text: `${item.code} - ${item.title}`,
      })),
    [data]
  )
}
